import { gql } from '@apollo/client'

export const FILE_FRAGMENT = gql`
  fragment FileFragment on DataroomFile {
    filename
    url
    mimetype
    filesize
  }
`

export const STAGE_FRAGMENT = gql`
  ${FILE_FRAGMENT}
  fragment StageFragment on Stage {
    id
    name
    notes
    timestamp
    files {
      ...FileFragment
    }
    createdAt
    updatedAt
  }
`
